import { RegionEnum } from "./applicant.enum";

export const COUNTRIES_OPTIONS = [
  {
    label: "form:address.country.CA",
    value: "CA",
  },
  {
    label: "form:address.country.US",
    value: "US",
  },
];

export const ALL_COUNTRIES_OPTIONS = [
  {
    label: "form:address.country.CA",
    value: "CA",
  },
  {
    label: "form:address.country.US",
    value: "US",
  },
  {
    value: "AF",
    label: "form:address.country.AF",
  },
  {
    value: "AX",
    label: "form:address.country.AX",
  },
  {
    value: "AL",
    label: "form:address.country.AL",
  },
  {
    value: "DZ",
    label: "form:address.country.DZ",
  },
  {
    value: "AS",
    label: "form:address.country.AS",
  },
  {
    value: "AD",
    label: "form:address.country.AD",
  },

  {
    value: "AO",
    label: "form:address.country.AO",
  },
  {
    value: "AI",
    label: "form:address.country.AI",
  },
  {
    value: "AQ",
    label: "form:address.country.AQ",
  },
  {
    value: "AG",
    label: "form:address.country.AG",
  },
  {
    value: "AR",
    label: "form:address.country.AR",
  },
  {
    value: "AM",
    label: "form:address.country.AM",
  },
  {
    value: "AW",
    label: "form:address.country.AW",
  },
  {
    value: "AU",
    label: "form:address.country.AU",
  },
  {
    value: "AT",
    label: "form:address.country.AT",
  },
  {
    value: "AZ",
    label: "form:address.country.AZ",
  },
  {
    value: "BS",
    label: "form:address.country.BS",
  },
  {
    value: "BH",
    label: "form:address.country.BH",
  },
  {
    value: "BD",
    label: "form:address.country.BD",
  },
  {
    value: "BB",
    label: "form:address.country.BB",
  },
  {
    value: "BY",
    label: "form:address.country.BY",
  },
  {
    value: "BE",
    label: "form:address.country.BE",
  },
  {
    value: "BZ",
    label: "form:address.country.BZ",
  },
  {
    value: "BJ",
    label: "form:address.country.BJ",
  },
  {
    value: "BM",
    label: "form:address.country.BM",
  },
  {
    value: "BT",
    label: "form:address.country.BT",
  },

  {
    value: "BO",
    label: "form:address.country.BO",
  },
  {
    value: "BA",
    label: "form:address.country.BA",
  },
  {
    value: "BW",
    label: "form:address.country.BW",
  },
  {
    value: "BV",
    label: "form:address.country.BV",
  },
  {
    value: "BR",
    label: "form:address.country.BR",
  },
  {
    value: "IO",
    label: "form:address.country.IO",
  },
  {
    value: "VG",
    label: "form:address.country.VG",
  },
  {
    value: "BN",
    label: "form:address.country.BN",
  },
  {
    value: "BG",
    label: "form:address.country.BG",
  },
  {
    value: "BF",
    label: "form:address.country.BF",
  },
  {
    value: "BI",
    label: "form:address.country.BI",
  },
  {
    value: "KH",
    label: "form:address.country.KH",
  },
  {
    value: "CM",
    label: "form:address.country.CM",
  },
  {
    value: "CV",
    label: "form:address.country.CV",
  },
  {
    value: "BQ",
    label: "form:address.country.BQ",
  },
  {
    value: "KY",
    label: "form:address.country.KY",
  },
  {
    value: "CF",
    label: "form:address.country.CF",
  },
  {
    value: "TD",
    label: "form:address.country.TD",
  },
  {
    value: "CL",
    label: "form:address.country.CL",
  },
  {
    value: "CN",
    label: "form:address.country.CN",
  },
  {
    value: "CX",
    label: "form:address.country.CX",
  },
  {
    value: "CC",
    label: "form:address.country.CC",
  },
  {
    value: "CO",
    label: "form:address.country.CO",
  },
  {
    value: "KM",
    label: "form:address.country.KM",
  },
  {
    value: "CG",
    label: "form:address.country.CG",
  },
  {
    value: "CD",
    label: "form:address.country.CD",
  },
  {
    value: "CK",
    label: "form:address.country.CK",
  },
  {
    value: "CR",
    label: "form:address.country.CR",
  },
  {
    value: "CI",
    label: "form:address.country.CI",
  },
  {
    value: "HR",
    label: "form:address.country.HR",
  },
  {
    value: "CU",
    label: "form:address.country.CU",
  },
  {
    value: "CW",
    label: "form:address.country.CW",
  },
  {
    value: "CY",
    label: "form:address.country.CY",
  },
  {
    value: "CZ",
    label: "form:address.country.CZ",
  },
  {
    value: "DK",
    label: "form:address.country.DK",
  },
  {
    value: "DJ",
    label: "form:address.country.DJ",
  },
  {
    value: "DM",
    label: "form:address.country.DM",
  },
  {
    value: "DO",
    label: "form:address.country.DO",
  },
  {
    value: "EC",
    label: "form:address.country.EC",
  },
  {
    value: "EG",
    label: "form:address.country.EG",
  },
  {
    value: "SV",
    label: "form:address.country.SV",
  },
  {
    value: "GQ",
    label: "form:address.country.GQ",
  },
  {
    value: "ER",
    label: "form:address.country.ER",
  },
  {
    value: "EE",
    label: "form:address.country.EE",
  },
  {
    value: "SZ",
    label: "form:address.country.SZ",
  },
  {
    value: "ET",
    label: "form:address.country.ET",
  },
  {
    value: "FK",
    label: "form:address.country.FK",
  },
  {
    value: "FO",
    label: "form:address.country.FO",
  },
  {
    value: "FJ",
    label: "form:address.country.FJ",
  },
  {
    value: "FI",
    label: "form:address.country.FI",
  },
  {
    value: "FR",
    label: "form:address.country.FR",
  },
  {
    value: "GF",
    label: "form:address.country.GF",
  },
  {
    value: "PF",
    label: "form:address.country.PF",
  },
  {
    value: "TF",
    label: "form:address.country.TF",
  },
  {
    value: "GA",
    label: "form:address.country.GA",
  },
  {
    value: "GM",
    label: "form:address.country.GM",
  },
  {
    value: "GE",
    label: "form:address.country.GE",
  },
  {
    value: "DE",
    label: "form:address.country.DE",
  },
  {
    value: "GH",
    label: "form:address.country.GH",
  },
  {
    value: "GI",
    label: "form:address.country.GI",
  },
  {
    value: "GR",
    label: "form:address.country.GR",
  },
  {
    value: "GL",
    label: "form:address.country.GL",
  },
  {
    value: "GD",
    label: "form:address.country.GD",
  },
  {
    value: "GP",
    label: "form:address.country.GP",
  },
  {
    value: "GU",
    label: "form:address.country.GU",
  },
  {
    value: "GT",
    label: "form:address.country.GT",
  },
  {
    value: "GG",
    label: "form:address.country.GG",
  },
  {
    value: "GN",
    label: "form:address.country.GN",
  },
  {
    value: "GW",
    label: "form:address.country.GW",
  },
  {
    value: "GY",
    label: "form:address.country.GY",
  },
  {
    value: "HT",
    label: "form:address.country.HT",
  },
  {
    value: "HM",
    label: "form:address.country.HM",
  },
  {
    value: "HN",
    label: "form:address.country.HN",
  },
  {
    value: "HK",
    label: "form:address.country.HK",
  },
  {
    value: "HU",
    label: "form:address.country.HU",
  },
  {
    value: "IS",
    label: "form:address.country.IS",
  },
  {
    value: "IN",
    label: "form:address.country.IN",
  },
  {
    value: "ID",
    label: "form:address.country.ID",
  },
  {
    value: "IR",
    label: "form:address.country.IR",
  },
  {
    value: "IQ",
    label: "form:address.country.IQ",
  },
  {
    value: "IE",
    label: "form:address.country.IE",
  },
  {
    value: "IM",
    label: "form:address.country.IM",
  },
  {
    value: "IL",
    label: "form:address.country.IL",
  },
  {
    value: "IT",
    label: "form:address.country.IT",
  },
  {
    value: "JM",
    label: "form:address.country.JM",
  },
  {
    value: "JP",
    label: "form:address.country.JP",
  },
  {
    value: "JE",
    label: "form:address.country.JE",
  },
  {
    value: "JO",
    label: "form:address.country.JO",
  },
  {
    value: "KZ",
    label: "form:address.country.KZ",
  },
  {
    value: "KE",
    label: "form:address.country.KE",
  },
  {
    value: "KI",
    label: "form:address.country.KI",
  },
  {
    value: "KW",
    label: "form:address.country.KW",
  },
  {
    value: "KG",
    label: "form:address.country.KG",
  },
  {
    value: "LA",
    label: "form:address.country.LA",
  },
  {
    value: "LV",
    label: "form:address.country.LV",
  },
  {
    value: "LB",
    label: "form:address.country.LB",
  },
  {
    value: "LS",
    label: "form:address.country.LS",
  },
  {
    value: "LR",
    label: "form:address.country.LR",
  },
  {
    value: "LY",
    label: "form:address.country.LY",
  },
  {
    value: "LI",
    label: "form:address.country.LI",
  },
  {
    value: "LT",
    label: "form:address.country.LT",
  },
  {
    value: "LU",
    label: "form:address.country.LU",
  },
  {
    value: "MO",
    label: "form:address.country.MO",
  },
  {
    value: "MG",
    label: "form:address.country.MG",
  },
  {
    value: "MW",
    label: "form:address.country.MW",
  },
  {
    value: "MY",
    label: "form:address.country.MY",
  },
  {
    value: "MV",
    label: "form:address.country.MV",
  },
  {
    value: "ML",
    label: "form:address.country.ML",
  },
  {
    value: "MT",
    label: "form:address.country.MT",
  },
  {
    value: "MH",
    label: "form:address.country.MH",
  },
  {
    value: "MQ",
    label: "form:address.country.MQ",
  },
  {
    value: "MR",
    label: "form:address.country.MR",
  },
  {
    value: "MU",
    label: "form:address.country.MU",
  },
  {
    value: "YT",
    label: "form:address.country.YT",
  },
  {
    value: "MX",
    label: "form:address.country.MX",
  },
  {
    value: "FM",
    label: "form:address.country.FM",
  },
  {
    value: "MD",
    label: "form:address.country.MD",
  },
  {
    value: "MC",
    label: "form:address.country.MC",
  },
  {
    value: "MN",
    label: "form:address.country.MN",
  },
  {
    value: "ME",
    label: "form:address.country.ME",
  },
  {
    value: "MS",
    label: "form:address.country.MS",
  },
  {
    value: "MA",
    label: "form:address.country.MA",
  },
  {
    value: "MZ",
    label: "form:address.country.MZ",
  },
  {
    value: "MM",
    label: "form:address.country.MM",
  },
  {
    value: "NA",
    label: "form:address.country.NA",
  },
  {
    value: "NR",
    label: "form:address.country.NR",
  },
  {
    value: "NP",
    label: "form:address.country.NP",
  },
  {
    value: "NL",
    label: "form:address.country.NL",
  },
  {
    value: "NC",
    label: "form:address.country.NC",
  },
  {
    value: "NZ",
    label: "form:address.country.NZ",
  },
  {
    value: "NI",
    label: "form:address.country.NI",
  },
  {
    value: "NE",
    label: "form:address.country.NE",
  },
  {
    value: "NG",
    label: "form:address.country.NG",
  },
  {
    value: "NU",
    label: "form:address.country.NU",
  },
  {
    value: "NF",
    label: "form:address.country.NF",
  },
  {
    value: "KP",
    label: "form:address.country.KP",
  },
  {
    value: "MK",
    label: "form:address.country.MK",
  },
  {
    value: "MP",
    label: "form:address.country.MP",
  },
  {
    value: "NO",
    label: "form:address.country.NO",
  },
  {
    value: "OM",
    label: "form:address.country.OM",
  },
  {
    value: "PK",
    label: "form:address.country.PK",
  },
  {
    value: "PW",
    label: "form:address.country.PW",
  },
  {
    value: "PS",
    label: "form:address.country.PS",
  },
  {
    value: "PA",
    label: "form:address.country.PA",
  },
  {
    value: "PG",
    label: "form:address.country.PG",
  },
  {
    value: "PY",
    label: "form:address.country.PY",
  },
  {
    value: "PE",
    label: "form:address.country.PE",
  },
  {
    value: "PH",
    label: "form:address.country.PH",
  },
  {
    value: "PN",
    label: "form:address.country.PN",
  },
  {
    value: "PL",
    label: "form:address.country.PL",
  },
  {
    value: "PT",
    label: "form:address.country.PT",
  },
  {
    value: "PR",
    label: "form:address.country.PR",
  },
  {
    value: "QA",
    label: "form:address.country.QA",
  },
  {
    value: "RE",
    label: "form:address.country.RE",
  },
  {
    value: "RO",
    label: "form:address.country.RO",
  },
  {
    value: "RU",
    label: "form:address.country.RU",
  },
  {
    value: "RW",
    label: "form:address.country.RW",
  },
  {
    value: "WS",
    label: "form:address.country.WS",
  },
  {
    value: "SM",
    label: "form:address.country.SM",
  },
  {
    value: "ST",
    label: "form:address.country.ST",
  },
  {
    value: "SA",
    label: "form:address.country.SA",
  },
  {
    value: "SN",
    label: "form:address.country.SN",
  },
  {
    value: "RS",
    label: "form:address.country.RS",
  },
  {
    value: "SC",
    label: "form:address.country.SC",
  },
  {
    value: "SL",
    label: "form:address.country.SL",
  },
  {
    value: "SG",
    label: "form:address.country.SG",
  },
  {
    value: "SX",
    label: "form:address.country.SX",
  },
  {
    value: "SK",
    label: "form:address.country.SK",
  },
  {
    value: "SI",
    label: "form:address.country.SI",
  },
  {
    value: "SB",
    label: "form:address.country.SB",
  },
  {
    value: "SO",
    label: "form:address.country.SO",
  },
  {
    value: "ZA",
    label: "form:address.country.ZA",
  },
  {
    value: "GS",
    label: "form:address.country.GS",
  },
  {
    value: "KR",
    label: "form:address.country.KR",
  },
  {
    value: "SS",
    label: "form:address.country.SS",
  },
  {
    value: "ES",
    label: "form:address.country.ES",
  },
  {
    value: "LK",
    label: "form:address.country.LK",
  },
  {
    value: "BL",
    label: "form:address.country.BL",
  },
  {
    value: "SH",
    label: "form:address.country.SH",
  },
  {
    value: "KN",
    label: "form:address.country.KN",
  },
  {
    value: "LC",
    label: "form:address.country.LC",
  },
  {
    value: "MF",
    label: "form:address.country.MF",
  },
  {
    value: "PM",
    label: "form:address.country.PM",
  },
  {
    value: "VC",
    label: "form:address.country.VC",
  },
  {
    value: "SD",
    label: "form:address.country.SD",
  },
  {
    value: "SR",
    label: "form:address.country.SR",
  },
  {
    value: "SJ",
    label: "form:address.country.SJ",
  },
  {
    value: "SE",
    label: "form:address.country.SE",
  },
  {
    value: "CH",
    label: "form:address.country.CH",
  },
  {
    value: "SY",
    label: "form:address.country.SY",
  },
  {
    value: "TW",
    label: "form:address.country.TW",
  },
  {
    value: "TJ",
    label: "form:address.country.TJ",
  },
  {
    value: "TZ",
    label: "form:address.country.TZ",
  },
  {
    value: "TH",
    label: "form:address.country.TH",
  },
  {
    value: "TL",
    label: "form:address.country.TL",
  },
  {
    value: "TG",
    label: "form:address.country.TG",
  },
  {
    value: "TK",
    label: "form:address.country.TK",
  },
  {
    value: "TO",
    label: "form:address.country.TO",
  },
  {
    value: "TT",
    label: "form:address.country.TT",
  },
  {
    value: "TN",
    label: "form:address.country.TN",
  },
  {
    value: "TR",
    label: "form:address.country.TR",
  },
  {
    value: "TM",
    label: "form:address.country.TM",
  },
  {
    value: "TC",
    label: "form:address.country.TC",
  },
  {
    value: "TV",
    label: "form:address.country.TV",
  },
  {
    value: "UM",
    label: "form:address.country.UM",
  },
  {
    value: "VI",
    label: "form:address.country.VI",
  },
  {
    value: "UG",
    label: "form:address.country.UG",
  },
  {
    value: "UA",
    label: "form:address.country.UA",
  },
  {
    value: "AE",
    label: "form:address.country.AE",
  },
  {
    value: "GB",
    label: "form:address.country.GB",
  },
  {
    value: "UY",
    label: "form:address.country.UY",
  },
  {
    value: "UZ",
    label: "form:address.country.UZ",
  },
  {
    value: "VU",
    label: "form:address.country.VU",
  },
  {
    value: "VA",
    label: "form:address.country.VA",
  },
  {
    value: "VE",
    label: "form:address.country.VE",
  },
  {
    value: "VN",
    label: "form:address.country.VN",
  },
  {
    value: "WF",
    label: "form:address.country.WF",
  },
  {
    value: "EH",
    label: "form:address.country.EH",
  },
  {
    value: "YE",
    label: "form:address.country.YE",
  },
  {
    value: "ZM",
    label: "form:address.country.ZM",
  },
  {
    value: "ZW",
    label: "form:address.country.ZW",
  },
];

export const PROVINCES_OPTIONS = [
  {
    value: RegionEnum.ON,
    label: "provinces:ON",
  },
  {
    value: RegionEnum.QC,
    label: "provinces:QC",
  },
  {
    value: RegionEnum.AB,
    label: "provinces:AB",
  },
  {
    value: RegionEnum.BC,
    label: "provinces:BC",
  },
  {
    value: RegionEnum.MB,
    label: "provinces:MB",
  },
  {
    value: RegionEnum.NB,
    label: "provinces:NB",
  },
  {
    value: RegionEnum.NS,
    label: "provinces:NS",
  },
  {
    value: RegionEnum.NL,
    label: "provinces:NL",
  },
  {
    value: RegionEnum.PE,
    label: "provinces:PE",
  },
  {
    value: RegionEnum.SK,
    label: "provinces:SK",
  },
  {
    value: RegionEnum.NT,
    label: "provinces:NT",
  },
  {
    value: RegionEnum.YT,
    label: "provinces:YT",
  },
  {
    value: RegionEnum.NU,
    label: "provinces:NU",
  },
];

// EN: https://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=53971
// FR: https://www23.statcan.gc.ca/imdb/p3VD_f.pl?Function=getVD&TVD=53971
export const US_STATES_OPTIONS = [
  { value: "AL", label: "us-states:AL" },
  { value: "AK", label: "us-states:AK" },
  { value: "AZ", label: "us-states:AZ" },
  { value: "AR", label: "us-states:AR" },
  { value: "CA", label: "us-states:CA" },
  { value: "CO", label: "us-states:CO" },
  { value: "CT", label: "us-states:CT" },
  { value: "DE", label: "us-states:DE" },
  { value: "DC", label: "us-states:DC" },
  { value: "FL", label: "us-states:FL" },
  { value: "GA", label: "us-states:GA" },
  { value: "HI", label: "us-states:HI" },
  { value: "ID", label: "us-states:ID" },
  { value: "IL", label: "us-states:IL" },
  { value: "IN", label: "us-states:IN" },
  { value: "IA", label: "us-states:IA" },
  { value: "KS", label: "us-states:KS" },
  { value: "KY", label: "us-states:KY" },
  { value: "LA", label: "us-states:LA" },
  { value: "ME", label: "us-states:ME" },
  { value: "MD", label: "us-states:MD" },
  { value: "MA", label: "us-states:MA" },
  { value: "MI", label: "us-states:MI" },
  { value: "MN", label: "us-states:MN" },
  { value: "MS", label: "us-states:MS" },
  { value: "MO", label: "us-states:MO" },
  { value: "MT", label: "us-states:MT" },
  { value: "NE", label: "us-states:NE" },
  { value: "NV", label: "us-states:NV" },
  { value: "NH", label: "us-states:NH" },
  { value: "NJ", label: "us-states:NJ" },
  { value: "NM", label: "us-states:NM" },
  { value: "NY", label: "us-states:NY" },
  { value: "NC", label: "us-states:NC" },
  { value: "ND", label: "us-states:ND" },
  { value: "OH", label: "us-states:OH" },
  { value: "OK", label: "us-states:OK" },
  { value: "OR", label: "us-states:OR" },
  { value: "PA", label: "us-states:PA" },
  { value: "RI", label: "us-states:RI" },
  { value: "SC", label: "us-states:SC" },
  { value: "SD", label: "us-states:SD" },
  { value: "TN", label: "us-states:TN" },
  { value: "TX", label: "us-states:TX" },
  { value: "UT", label: "us-states:UT" },
  { value: "VT", label: "us-states:VT" },
  { value: "VA", label: "us-states:VA" },
  { value: "WA", label: "us-states:WA" },
  { value: "WV", label: "us-states:WV" },
  { value: "WI", label: "us-states:WI" },
  { value: "WY", label: "us-states:WY" },
];

export const MX_STATES_OPTIONS = [
  { value: "AG", label: "mx-states:AG" },
  { value: "BA", label: "mx-states:BA" },
  { value: "BJ", label: "mx-states:BJ" },
  { value: "CE", label: "mx-states:CE" },
  { value: "CI", label: "mx-states:CI" },
  { value: "CH", label: "mx-states:CH" },
  { value: "CU", label: "mx-states:CU" },
  { value: "CL", label: "mx-states:CL" },
  { value: "DF", label: "mx-states:DF" },
  { value: "DO", label: "mx-states:DO" },
  { value: "GU", label: "mx-states:GU" },
  { value: "GR", label: "mx-states:GR" },
  { value: "HL", label: "mx-states:HL" },
  { value: "JL", label: "mx-states:JL" },
  { value: "MX", label: "mx-states:MX" },
  { value: "MC", label: "mx-states:MC" },
  { value: "MR", label: "mx-states:MR" },
  { value: "NA", label: "mx-states:NA" },
  { value: "NL", label: "mx-states:NL" },
  { value: "OA", label: "mx-states:OA" },
  { value: "PB", label: "mx-states:PB" },
  { value: "QU", label: "mx-states:QU" },
  { value: "QR", label: "mx-states:QR" },
  { value: "SL", label: "mx-states:SL" },
  { value: "SI", label: "mx-states:SI" },
  { value: "SO", label: "mx-states:SO" },
  { value: "TB", label: "mx-states:TB" },
  { value: "TA", label: "mx-states:TA" },
  { value: "TL", label: "mx-states:TL" },
  { value: "VC", label: "mx-states:VC" },
  { value: "YU", label: "mx-states:YU" },
  { value: "ZA", label: "mx-states:ZA" },
];